/* eslint-disable promise/catch-or-return */
import context from '@/context'
import {
  processUserReport,
  getCellMetadataFromReportSubmissionData,
  mergeSourceData,
  mergeMetadata
} from '@/store/utils/reportUtils'
import getComponentKey from '@/utils/getComponentKey'
import { allowErrorDialog } from '@/utils/fetch'

const initialState = {
  fetching: false,
  fetchingId: null,
  adding: false,
  removing: false,
  attachmentsKey: getComponentKey(),
  outputReport: null,
  sourceHeaders: null,
  sourceRowHeaders: null,
  sourceDataUpdating: false,
  sourceDataRecalculating: false,
  sourceData: [],
  cellMetadata: [],
  rowFilter: null
}

export const actionTypes = {
  OutputReportFetching: 'outputReport/fetching',
  OutputReportFetched: 'outputReport/fetched',
  OutputReportAttachmentAdding: 'outputReport/attachment/adding',
  OutputReportAttachmentAdded: 'outputReport/attachment/added',
  OutputReportAttachmentRemoving: 'outputReport/attachment/removing',
  OutputReportAttachmentRemoved: 'outputReport/attachment/removed',
  OutputReportError: 'outputReport/error',
  ReportLocked: 'outputReport/lock',

  SourceDataUpdated: 'outputReport/sourceDataUpdated'
}

const getInternal = (dispatch, getState, reportId, reportGroupId, rowFilter) => {
  dispatch({ type: actionTypes.OutputReportFetching, data: reportId })

  const resp = response => {
    try {
      const grid = processUserReport(response)
      const sourceData = response.reportSubmissionCells

      const cellMetadata = getCellMetadataFromReportSubmissionData(response.reportSubmissionCells)

      dispatch({ type: actionTypes.OutputReportFetched, data: { grid, sourceData, cellMetadata, rowFilter } })
    } catch (err) {
      dispatch({ type: actionTypes.OutputReportError, update: { fetching: false, fetchingId: null, rowFilter } })
    }
  }

  const err = () => dispatch({ type: actionTypes.OutputReportError, update: { fetching: false, fetchingId: null, rowFilter } })

  if (rowFilter && ((rowFilter.bankTypes && rowFilter.bankTypes.length) || (rowFilter.institutionGroups && rowFilter.institutionGroups.length))) {
    context.api.outputReportService.getFiltered(reportId, reportGroupId, rowFilter.bankTypes, rowFilter.institutionGroups).then(resp).catch(err)
  } else if (!reportGroupId)context.api.outputReportService.get(reportId, allowErrorDialog).then(resp).catch(err)
  else context.api.outputReportService.getByGroup(reportGroupId, reportId, allowErrorDialog).then(resp).catch(err)
}

export const actionCreators = {
  get: (id, groupId) => (dispatch, getState) => {
    getInternal(dispatch, getState, id, groupId)
  },
  getFiltered: (id, reportGroupId, bankTypes, institutionGroups) => (dispatch, getState) => {
    getInternal(dispatch, getState, id, reportGroupId, { bankTypes, institutionGroups })
  },
  addAttachments: (input) => (dispatch) => {
    dispatch({ type: actionTypes.OutputReportAttachmentAdding })
    context.api.outputReportService.addAttachments(input)
      .then(response => {
        dispatch({ type: actionTypes.OutputReportAttachmentAdded })
      })
      .catch(() => dispatch({ type: actionTypes.OutputReportError, update: { adding: false } }))
  },
  removeAttachments: (input) => (dispatch) => {
    dispatch({ type: actionTypes.OutputReportAttachmentRemoving })
    context.api.outputReportService.removeAttachments(input)
      .then(response => {
        dispatch({ type: actionTypes.OutputReportAttachmentRemoved })
      })
      .catch(() => dispatch({ type: actionTypes.OutputReportError, update: { removing: false } }))
  },
  clearReportData: () => (dispatch, getState) => {
    dispatch({ type: actionTypes.OutputReportFetching })

    const state = getState()

    context.api.outputReportService.clearReportData(state.outputReports.outputReport.id)
      .then(response => {
        getInternal(dispatch, getState, state.outputReports.outputReport.id)
      })
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.OutputReportFetching: return { ...state, fetching: true, fetchingId: action.data }
    case actionTypes.OutputReportFetched:
      return {
        ...state,
        fetching: false,
        fetchingId: null,
        sourceDataSaving: false,
        sourceDataSavingError: false,
        outputReport: action.data.grid,
        sourceRowHeaders: action.data.grid.allRows,
        sourceHeaders: action.data.grid.allCols,
        sourceData: action.data.sourceData,
        cellMetadata: action.data.cellMetadata,
        rowFilter: action.data.rowFilter,
        key: state.key + 1
      }
    case actionTypes.OutputReportAttachmentAdding: return { ...state, adding: true }
    case actionTypes.OutputReportAttachmentAdded: return { ...state, adding: false, attachmentsKey: getComponentKey() }
    case actionTypes.OutputReportAttachmentRemoving: return { ...state, removing: true }
    case actionTypes.OutputReportAttachmentRemoved: return { ...state, removing: false, attachmentsKey: getComponentKey() }
    case actionTypes.OutputReportError: return { ...state, ...action.update }
    case actionTypes.SourceDataUpdated: {
      const newState = { ...state,
        sourceDataUpdating: false,
        scrollToRow: null
      }

      if (action.data.mergeData) {
        newState.sourceData = action.data.data ? mergeSourceData(state.sourceData, action.data.data) : state.sourceData
        newState.cellMetadata = action.data.cellMetadata ? mergeMetadata(state.cellMetadata, action.data.cellMetadata) : state.cellMetadata
      } else {
        newState.sourceData = action.data.data ? action.data.data : state.sourceData
        newState.cellMetadata = action.data.cellMetadata ? action.data.cellMetadata : state.cellMetadata
      }

      return newState
    }
    case actionTypes.ReportLocked: return {
      ...state,
      outputReport: { ...state.outputReport, outputReportState: 1 },
      sourceData: action.data.data,
      cellMetadata: action.data.cellMetadata
    }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/OutputReports.js